module.exports = {"name":"LicensePlugin","version":"2.5.1","description":"","repository":{"type":"git","url":"https://github.com/Graylog2/graylog-plugin-license"},"scripts":{"build":"webpack --bail"},"keywords":["graylog"],"author":"Graylog, Inc. <hello@graylog.com>","license":"UNLICENSED","private":true,"dependencies":{},"devDependencies":{"graylog-web-plugin":"file:../../graylog2-server/graylog2-web-interface/packages/graylog-web-plugin"}}


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 149
// module chunks = 0